<header [style]="background?'background: url(/assets/'+background+'.webp) no-repeat top center/100% 100%;':''">
    <div class="mask" [class]="background?'background-primary':'background-light'">
        <div class="container header-page-content">
            <div [class]="background?'header-page-text header-page-text-white':'header-page-text text-primary'">
                <h1 [class]="background?'h1-dark':'h1-light'">{{heading}}</h1>
                <p *ngFor="let description_line of description">
                    {{description_line}}
                </p>
                <a *ngIf="link" [href]="link" [attr.aria-label]="linkAriaLabel">{{linkLabel}}</a>
            </div>
            <div class="header-breadcrumb">
                <ol [class]="background?'breadcrumb':'breadcrumb-light'">
                    <li *ngFor="let breadcrumb of breadcrumbs; let i = index"
                        [class]="(background?'breadcrumb-item':'') + (i == breadcrumbs.length - 1?' active':'')">
                        <a *ngIf="i < breadcrumbs.length - 1; else nolink" [routerLink]="breadcrumb['link']"
                            [href]="breadcrumb['link']" [attr.aria-label]="breadcrumb['ariaLabel']">
                            {{breadcrumb['label']}}
                        </a>
                        <ng-template #nolink>
                            {{breadcrumb['label']}}
                        </ng-template>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</header>